/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ExecutionPlanTaskDto } from './ExecutionPlanTaskDto';
import {
    ExecutionPlanTaskDtoFromJSON,
    ExecutionPlanTaskDtoFromJSONTyped,
    ExecutionPlanTaskDtoToJSON,
    ExecutionPlanTaskDtoToJSONTyped,
} from './ExecutionPlanTaskDto';

/**
 * 
 * @export
 * @interface ExecutionPlanTaskWithContextDto
 */
export interface ExecutionPlanTaskWithContextDto {
    /**
     * 
     * @type {string}
     * @memberof ExecutionPlanTaskWithContextDto
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecutionPlanTaskWithContextDto
     */
    initiativeId?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecutionPlanTaskWithContextDto
     */
    initiativeName?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecutionPlanTaskWithContextDto
     */
    planName?: string;
    /**
     * 
     * @type {ExecutionPlanTaskDto}
     * @memberof ExecutionPlanTaskWithContextDto
     */
    task?: ExecutionPlanTaskDto;
}

/**
 * Check if a given object implements the ExecutionPlanTaskWithContextDto interface.
 */
export function instanceOfExecutionPlanTaskWithContextDto(value: object): value is ExecutionPlanTaskWithContextDto {
    return true;
}

export function ExecutionPlanTaskWithContextDtoFromJSON(json: any): ExecutionPlanTaskWithContextDto {
    return ExecutionPlanTaskWithContextDtoFromJSONTyped(json, false);
}

export function ExecutionPlanTaskWithContextDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecutionPlanTaskWithContextDto {
    if (json == null) {
        return json;
    }
    return {
        
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'initiativeId': json['initiativeId'] == null ? undefined : json['initiativeId'],
        'initiativeName': json['initiativeName'] == null ? undefined : json['initiativeName'],
        'planName': json['planName'] == null ? undefined : json['planName'],
        'task': json['task'] == null ? undefined : ExecutionPlanTaskDtoFromJSON(json['task']),
    };
}

export function ExecutionPlanTaskWithContextDtoToJSON(json: any): ExecutionPlanTaskWithContextDto {
    return ExecutionPlanTaskWithContextDtoToJSONTyped(json, false);
}

export function ExecutionPlanTaskWithContextDtoToJSONTyped(value?: ExecutionPlanTaskWithContextDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tenantId': value['tenantId'],
        'initiativeId': value['initiativeId'],
        'initiativeName': value['initiativeName'],
        'planName': value['planName'],
        'task': ExecutionPlanTaskDtoToJSON(value['task']),
    };
}

